import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { UserState } from '../actions/user';

interface IPayloadOpenDrawer {
    isEditMode: boolean;
    user?: UserState | undefined;
}

export interface IUserEditState {
    isDrawerOpen: boolean;
    isEditMode: boolean;
    isListToRefresh: boolean;
    currentUser: UserState | undefined;
}

const initialState: IUserEditState = {
    isDrawerOpen: false,
    isEditMode: false,
    isListToRefresh: false,
    currentUser: undefined
};

const userEditSlice = createSlice({
    name: 'userEdit',
    initialState,
    reducers: {
        openDrawer: (state: IUserEditState, action: PayloadAction<IPayloadOpenDrawer>) => {
            state.isDrawerOpen = true;
            state.isEditMode = action.payload.isEditMode || false;
            state.currentUser = action.payload.user || undefined;
        },
        closeDrawer: (state) => {
            state.isDrawerOpen = false;
            state.isEditMode = false;
            state.currentUser = undefined;
        },
        toRefreshList: (state) => {
            state.isListToRefresh = true;
        },
        refreshedList: (state) => {
            state.isListToRefresh = false;
        }
    }
});

export const { openDrawer, closeDrawer, refreshedList, toRefreshList } = userEditSlice.actions;
export default userEditSlice.reducer;
